module.exports = __webpack_public_path__ + "img/9ta_docs.99351bb7.svg";